<template>
  <div>
    <stormy-confirmation-dialog
      :show="show"
      :title="title"
      :message="message"
      :text-confirmation="textConfirmation"
      :text-cancel="textCancel"
      :width="width"
      :variant="variant"
      @cancel="close(false)"
      @confirm="close(true)"
    />
  </div>
</template>

<script setup>
import { useProp } from '@/composables/useProp.js'
import { closeDialog } from 'vue3-promise-dialog'
import { ref } from 'vue'

defineProps({
  title: useProp(String, 'Löschen bestätigen'),
  message: useProp(String, 'Möchtest Du den Datensatz wirklich löschen?'),
  width: useProp(String, 'sm'),
  textConfirmation: useProp(String, 'Löschen'),
  textCancel: useProp(String, 'Abbrechen'),
  variant: useProp(String, 'danger')
})

const show = ref(true)

const close = (value) => {
  show.value = false
  closeDialog(value)
}

</script>
